import { useUserStore } from '/@/store/modules/user'
import { getLocal, saveLocal } from '/@/utils'
import pagesJson from '../pages.json'

const CODE_MESSAGE: any = {
  2000: '服务器成功返回请求数据',
  201: '新建或修改数据成功',
  202: '一个请求已经进入后台排队(异步任务)',
  204: '删除数据成功',
  4000: '发出信息有误',
  400: '发出信息有误',
  401: '用户没有权限(令牌失效、用户名、密码错误、登录过期)',
  402: '令牌过期',
  403: '用户得到授权，但是访问是被禁止的',
  404: '访问资源不存在',
  406: '请求格式不可得',
  410: '请求资源被永久删除，且不会被看到',
  500: '服务器发生错误',
  502: '网关错误',
  503: '服务不可用，服务器暂时过载或维护',
  504: '网关超时',
}
const request: any = (options: any, isRetry = false) => {
  const userStore = useUserStore()
  const { resetAll, setToken } = userStore
  // 判断当前页面是否需要登录
  const pages = getCurrentPages();
  let currentPath = '';
  // #ifdef H5
  // 获取当前路径
  let hash = window.location.hash;
  if (hash) {
    // 去掉前面的 /#
    currentPath = hash.split('?')[0].replace(/^#/, '');
  } else {
    currentPath = window.location.href;
  }
  // #endif
  if (pages && pages.length > 0) {
    currentPath = pages[pages.length - 1].route ? ('/' + pages[pages.length - 1].route) : '';
    if (!currentPath.startsWith('/')) currentPath = '/' + currentPath;
  }
  let noNeedLogin = false;
  if (pagesJson.pages) {
    const found = pagesJson.pages.find(p => ('/pages/' + p.path) === currentPath || p.path === currentPath.replace(/^\//, ''));
    if (found && found.noNeedLogin) noNeedLogin = true;
  }
  if (!noNeedLogin && pagesJson.subPackages) {
    for (const pkg of pagesJson.subPackages) {
      if (pkg.pages) {
        const found = pkg.pages.find(p => ('/' + pkg.root + '/' + p.path) === currentPath || (pkg.root + '/' + p.path) === currentPath.replace(/^\//, ''));
        if (found && found.noNeedLogin) noNeedLogin = true;
      }
    }
  }

  // 1. 返回 Promise 对象
  return new Promise((resolve, reject) => {
    uni.request({
      ...options,
      // 响应成功
      success(res: any) {
        let data = res.data
        // 状态码 2xx，参考 axios 的设计
        if (data.code == 2000) {
          // 2.1 提取核心数据 res.data
          resolve(data)
        } else if (data.code == 401) {
          if (typeof data.msg == 'string') {
            $baseMessageTop(data.msg, 'error')
          }
          // 401错误，尝试刷新token（仅重试一次，且仅需要登录的页面）
          if (!noNeedLogin && !isRetry) {
            refreshToken().then((refreshRes: any) => {
              const refreshData = refreshRes[1]?.data || refreshRes.data // uni.request返回[err, res]或res
              if (refreshData && refreshData.code === 2000 && refreshData.data) {
                // 假设后端返回格式为 { code: 2000, data: { access: 'xxx', refresh: 'yyy' } }
                setToken(refreshData.data.access, refreshData.data.refresh)
                // 重新发起原请求，带新token
                const newOptions = { ...options }
                // 重新注入Authorization
                newOptions.header = {
                  ...newOptions.header,
                  Authorization: `JWT ${refreshData.data.access}`,
                }
                request(newOptions, true).then(resolve).catch(reject)
                return
              } else {
                // 刷新失败，清理并跳转登录
                resetAll().then(() => {
                  uni.redirectTo({ url: `/pages/login/index` })
                })
                reject(data)
              }
            }).catch(() => {
              resetAll().then(() => {
                uni.redirectTo({ url: `/pages/login/index` })
              })
              reject(data)
            })
          } else {
            // 已重试过或无需登录，直接清理
            if (!noNeedLogin) {
              resetAll().then(() => {
                uni.redirectTo({ url: `/pages/login/index` })
              })
            }
            reject(data)
          }
        } else if (data.code == 500) {
          $baseMessageTop('系统异常请联系管理员', 'error')
          reject(data)
        } else if (data.code == 4000 || data.code == 400) {
          // 其他错误 -> 根据后端错误信息轻提示
          if (data.msg === '身份认证信息未提供。') {
            if (!noNeedLogin) {
              resetAll().then(() => {
                uni.redirectTo({
                  url: `/pages/login/index`,
                })
              })
            }
          }
          if (typeof data.msg == 'string' && data.msg !== '身份认证信息未提供。') {
            $baseMessageTop(data.msg, 'error')
          }
          reject(data)
        } else {
          // 其他错误 -> 根据后端错误信息轻提示
          $baseMessageTop(CODE_MESSAGE[data.code], 'error')
          reject(data)
        }
      },
      // 响应失败
      fail(err: any) {
        $baseMessageTop('系统异常请联系管理员', 'error')
        reject(err)
      },
    })
  })
}

// 刷新token
const refreshToken = () => {
  const refresh = getLocal('refresh_token')
  return uni.request({
    url: '/token/refresh/',
    method: 'POST',
    data: { refresh: refresh },
  })
}

const instance: any = (data: any) => {
  return request(data)
}
export default instance
